import * as cookies from "@kiwicom/cookies"

export const AFFILID_FALLBACK = "skypicker"

// Safe affilid with "skypicker" default fallback
// @deprecated use getAffilId from options/selector instead
const SAFE_AFFILID =
  cookies.load("SKYPICKER_AFFILIATE") ||
  (typeof window !== "undefined" &&
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    window.SP_GLOBALS &&
    window.SP_GLOBALS.SKYPICKER_AFFILIATE !== "undefined" &&
    window.SP_GLOBALS.SKYPICKER_AFFILIATE) ||
  AFFILID_FALLBACK

// isEqual to set affilid
// SAFE_AFFILID @deprecated, pass always with setAffilid
export const isSetAffilId = (affilId: string, setAffilid: string = SAFE_AFFILID) =>
  setAffilid === affilId || (Boolean(setAffilid) && setAffilid.startsWith(`${affilId}_`))

// BizDev agreed priority of getting affilId
// 0. AffilId in URL
// 1. AffilId in Cookies
// 2. User AffilId from BE
// 3. Branding affilid fallback
// 4. Should not be needed "skypicker" fallback
export const getAffilidAccordingToPriority = (
  affilIdRequest?: string,
  affilIdCookies?: string,
  affilIdUser?: string,
  affilIdBranding?: string,
  affilCustomFallback?: string,
) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  affilIdRequest ||
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  affilIdCookies ||
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  affilIdUser ||
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  affilIdBranding ||
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  affilCustomFallback ||
  AFFILID_FALLBACK

// Discard market information `skypicker_cz` -> `skypicker`
export const formatSimpleAffilId = (affilId?: string | null) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  affilId && affilId.includes("_") ? affilId.split("_")[0] : affilId
